import {jsx as $dgBb7$jsx, Fragment as $dgBb7$Fragment, jsxs as $dgBb7$jsxs} from "react/jsx-runtime";
import $dgBb7$react, {useState as $dgBb7$useState, useRef as $dgBb7$useRef, useCallback as $dgBb7$useCallback, useEffect as $dgBb7$useEffect} from "react";
import {MessageInfo as $dgBb7$MessageInfo, CloseGray as $dgBb7$CloseGray} from "@komponentkassen/svv-icons";
import $dgBb7$focustrapreact from "focus-trap-react";
import {createPortal as $dgBb7$createPortal} from "react-dom";
import $dgBb7$classnames from "classnames";







// Render when modal is visible to prevent scroll on body
const $f3c0fef8a6cd553c$var$BODY_CSS = `
    body {
        overflow: hidden !important;
        position: relative !important;
        padding-left: 0;
        padding-top: 0;
        padding-right: 0;
        margin-left: 0;
        margin-top: 0;
        margin-right: 0 !important;
    }
`;
function $f3c0fef8a6cd553c$export$eec41cd03e81a74({ show: show , title: title , children: children , useInfoIcon: useInfoIcon , onClose: onClose , disableClickOutside: disableClickOutside , rejectButton: rejectButton , acceptButton: acceptButton , disableCloseOnRejectClick: disableCloseOnRejectClick = false , disableCloseOnAcceptClick: disableCloseOnAcceptClick = false , removeCloseButton: removeCloseButton = false , closeText: closeText = "Lukk" , className: className  }) {
    // Ha en lokal state for om modalen er åpen eller ikke.
    // Brukes for å håndtere aria-hidden på sibling-elementer samt cleanup
    // av eventlistenere
    const [isVisible, setIsVisible] = (0, $dgBb7$useState)(false);
    const modalRef = (0, $dgBb7$useRef)(null);
    const backdropRef = (0, $dgBb7$useRef)(null);
    const toggleAriaHiddenOnSiblings = ()=>{
        [
            ...modalRef?.current?.parentNode?.children ?? []
        ].forEach((el)=>{
            if (el !== modalRef.current) {
                if (el.hasAttribute("aria-hidden")) el.removeAttribute("aria-hidden");
                else el.setAttribute("aria-hidden", "true");
            }
        });
    };
    const handleOnOpen = ()=>{
        setIsVisible(true);
    };
    const handleOnClose = (0, $dgBb7$useCallback)(()=>{
        toggleAriaHiddenOnSiblings();
        setIsVisible(false);
        onClose();
    }, [
        onClose
    ]);
    const handleEscape = (0, $dgBb7$useCallback)((e)=>{
        if (e.key.toLowerCase() === "escape") handleOnClose();
    }, [
        handleOnClose
    ]);
    (0, $dgBb7$useEffect)(()=>{
        if (show) handleOnOpen();
    }, [
        show
    ]);
    (0, $dgBb7$useEffect)(()=>{
        if (isVisible) {
            const backdrop = backdropRef.current;
            toggleAriaHiddenOnSiblings();
            if (backdrop && !disableClickOutside) backdrop.addEventListener("click", handleOnClose);
            window.addEventListener("keydown", handleEscape);
            return ()=>{
                backdrop?.removeEventListener("click", handleOnClose);
                window.removeEventListener("keydown", handleEscape);
            };
        }
        return undefined;
    }, [
        isVisible,
        backdropRef,
        disableClickOutside,
        handleEscape,
        handleOnClose
    ]);
    const renderDismissButton = ()=>{
        if (rejectButton) return /*#__PURE__*/ (0, $dgBb7$react).cloneElement(rejectButton, {
            ...rejectButton.props,
            onClick: (e)=>{
                if (!disableCloseOnRejectClick) handleOnClose();
                if (rejectButton.props.onClick) rejectButton.props.onClick(e);
            }
        });
        return null;
    };
    const renderConfirmButton = ()=>{
        if (acceptButton) return /*#__PURE__*/ (0, $dgBb7$react).cloneElement(acceptButton, {
            ...acceptButton.props,
            onClick: (e)=>{
                if (!disableCloseOnAcceptClick) handleOnClose();
                if (acceptButton.props.onClick) acceptButton.props.onClick(e);
            }
        });
        return null;
    };
    return isVisible ? /*#__PURE__*/ (0, $dgBb7$jsx)((0, $dgBb7$Fragment), {
        children: /*#__PURE__*/ (0, $dgBb7$createPortal)(/*#__PURE__*/ (0, $dgBb7$jsx)((0, $dgBb7$focustrapreact), {
            focusTrapOptions: {
                initialFocus: "#dialog-title"
            },
            children: /*#__PURE__*/ (0, $dgBb7$jsxs)("div", {
                className: (0, $dgBb7$classnames)(className, "svv-modal"),
                role: "dialog",
                "aria-modal": "true",
                "aria-labelledby": "dialog-title",
                ref: modalRef,
                children: [
                    /*#__PURE__*/ (0, $dgBb7$jsx)("style", {
                        children: $f3c0fef8a6cd553c$var$BODY_CSS
                    }),
                    /*#__PURE__*/ (0, $dgBb7$jsx)("div", {
                        className: "svv-modal__backdrop",
                        "data-testid": "backdropId",
                        ref: backdropRef
                    }),
                    /*#__PURE__*/ (0, $dgBb7$jsxs)("div", {
                        className: "svv-modal__content",
                        children: [
                            /*#__PURE__*/ (0, $dgBb7$jsxs)("div", {
                                className: "svv-modal_center_items svv-padding-bottom--px16",
                                children: [
                                    useInfoIcon && /*#__PURE__*/ (0, $dgBb7$jsx)((0, $dgBb7$MessageInfo), {
                                        "aria-hidden": true,
                                        className: "svv-modal_info_icon"
                                    }),
                                    /*#__PURE__*/ (0, $dgBb7$jsx)("h2", {
                                        className: "svv-modal__header",
                                        id: "dialog-title",
                                        tabIndex: -1,
                                        children: title
                                    })
                                ]
                            }),
                            children,
                            (acceptButton || rejectButton) && /*#__PURE__*/ (0, $dgBb7$jsxs)("div", {
                                className: "svv-modal__content__button-row",
                                children: [
                                    rejectButton && renderDismissButton(),
                                    acceptButton && renderConfirmButton()
                                ]
                            }),
                            !removeCloseButton && /*#__PURE__*/ (0, $dgBb7$jsxs)("button", {
                                className: "info-message__close-button",
                                type: "button",
                                onClick: handleOnClose,
                                children: [
                                    /*#__PURE__*/ (0, $dgBb7$jsx)((0, $dgBb7$CloseGray), {
                                        "aria-hidden": true,
                                        className: "svv-modal_close_icon"
                                    }),
                                    /*#__PURE__*/ (0, $dgBb7$jsx)("span", {
                                        children: closeText
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        }), document.body)
    }) : null;
}




export {$f3c0fef8a6cd553c$export$eec41cd03e81a74 as SVVModal};
//# sourceMappingURL=module.js.map
